/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './SideBar.style';

import Branding from 'src/shared/app/nav/component/branding/Branding';
import SkipNavLink from 'src/shared/app/nav/component/skip/SkipNavLink';

type Props = {
  layoutClass?: string,
  children?: React.Node,
};

const useStyles = createUseStyles(styles);

const SideBar = ({ layoutClass, children }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const childrenElt = children && (
    <div className={classes.children}>{children}</div>
  );

  return (
    <aside className={classNames(classes.root, layoutClass)}>
      <SkipNavLink />
      <Branding />
      {childrenElt}
    </aside>
  );
};

export default compose(React.memo)(SideBar);
